import * as React from 'react';
import { Input, InputLabel, InputAdornment } from '@mui/material';
import { FormControl } from '@mui/material';
import {IconButton} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import  { withStyles } from '@mui/styles';
import * as request from 'superagent';
import {APIError} from '~common/lib/types';
import { WithStyles, StyleRules, ClassNameMap } from '@mui/styles/withStyles';
import { Theme } from '@mui/styles';
import {Button} from '@mui/material';
import {Typography} from '@mui/material';
import {Paper} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
	container: {
		marginTop: 40,
		display: 'flex',
		justifyContent: 'center'
	},
	paper: {
		padding: 30,
		backgroundColor: 'white'
	},
	textField: {
		marginTop: 15,
		width: 350
	},
	passwordField: {
		width: 350
	},
	form: {
		width: 350,
		textAlign: 'left'
	},
	buttonBar: {
		textAlign: 'right',
		marginTop: 30
	},
	button: {
		width: 180
	},
	error: {
		color: 'red'
	}
});

interface Props extends React.HTMLProps<HTMLDivElement> {
	userName:any
}

type State = {
	userName: string;
	showPassword: boolean;
	showNewPassword: boolean;
	showConfirmPassword: boolean;
	data: any;
	error?: any;
};

class ResetChangePassword extends React.Component<Props & WithStyles<keyof typeof styles>, State> {
	constructor(props: Props & WithStyles<keyof typeof styles>) {
		super(props, {});
		this.state = {
			userName: this.props.userName,
			showPassword: false,
			showNewPassword: false,
			showConfirmPassword: false,
			data: {
				password: '',
				confirmPassword: ''
			}
		};
	}

	UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {}

	handleClickShowPasssword = () => {
		this.setState({ showPassword: !this.state.showPassword });
	};

	handleClickShowNewPasssword = () => {
		this.setState({ showNewPassword: !this.state.showNewPassword });
	};

	handleClickShowConfirmPasssword = () => {
		this.setState({ showConfirmPassword: !this.state.showConfirmPassword });
	};

	handleChange = (prop: string) => {
		return (event: any) => {
			const state = this.state;
			state.data[prop] = event.target.value;
			this.setState(state);
		};
	};

	updatePassword = () => {
		let {data} = this.state;
		data.userName = this.state.userName;

		request.post('/api/auth/users/reset-password')
		.send(this.state.data)
		.then((response:request.Response) => {
			if (response.status == 200 && response.body.updated) {
				window.location.href = "/login"
			} else if (response.body.error) {
				this.setState({
					error: response.body.error
				})
			}
		})
	}

	parseMessages = (messages) => {
		const msgs = messages.split("|")
		let html = msgs.map((m)=>{
			return (<li>{m}</li>)
		})
		return (<ul>{html}</ul>)
	}
	render() {
		var self = this;

		const { classes }: { classes: ClassNameMap } = this.props;
		const app = (window as any).App || {};
		const {error} = this.state

		return (
			<div className={classes.container}>
				<Paper className={classes.paper}>
					{(error && <Typography className={classes.error} variant="subtitle1" gutterBottom>
							{this.parseMessages(error)}
						</Typography>
					)}
					<form className={classes.form} noValidate autoComplete="off" method="POST">
						<Typography variant="subtitle1" gutterBottom>
							Change Password
						</Typography>
						{!app.flash && (
							<Typography gutterBottom>Please provide and confirm your new password.</Typography>
						)}
						{app.flash &&
						app.flash.type == 'error' && (
							<Typography variant="subtitle1" color="error">
								{app.flash.message}
							</Typography>
						)}
						{app.flash &&
						app.flash.key == 'success' && (
							<Typography variant="subtitle1" color="primary">
								Your password has been reset. <a href="/login">Click here to log in.</a>
							</Typography>
						)}
						<div>
						<input
							type="hidden"
							name="step"
							value={"resetpassword"}
						/>
						<input
							type="hidden"
							name="userName"
							value={this.props.userName}
						/>
							<FormControl>
								<InputLabel htmlFor="password">Current Password</InputLabel>
								<Input
									name="password"
									type={self.state.showPassword ? 'text' : 'password'}
									value={self.state.data.password}
									onChange={self.handleChange('password')}
									className={classes.passwordField}
									endAdornment={
										<InputAdornment position="end">
											<IconButton size="large" onClick={self.handleClickShowPasssword}>
												{self.state.showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl>
								<InputLabel htmlFor="newPassword">New Password</InputLabel>
								<Input
									name="newPassword"
									type={self.state.showNewPassword ? 'text' : 'password'}
									value={self.state.data.newPassword}
									onChange={self.handleChange('newPassword')}
									className={classes.passwordField}
									endAdornment={
										<InputAdornment position="end">
											<IconButton size="large" onClick={self.handleClickShowNewPasssword}>
												{self.state.showNewPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</div>
						<div>
							<FormControl>
								<InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
								<Input
									name="confirmPassword"
									type={self.state.showConfirmPassword ? 'text' : 'password'}
									value={self.state.data.confirmPassword}
									onChange={self.handleChange('confirmPassword')}
									className={classes.passwordField}
									endAdornment={
										<InputAdornment position="end">
											<IconButton size="large" onClick={self.handleClickShowConfirmPasssword}>
												{self.state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>
						</div>
						<div className={classes.buttonBar}>
							<Button
								onClick={this.updatePassword}
								variant="contained"
								color="primary"
								disabled={!this.state.data.newPassword || this.state.data.newPassword !== this.state.data.confirmPassword}
								className={classes.button}
							>
								Change Password
							</Button>
						</div>
					</form>
				</Paper>
			</div>
		);
	}
}

export default withStyles(styles)(ResetChangePassword);
